export default "__VITE_ASSET__BP538sRi__"